import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _isEqual from "lodash/isEqual";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.regexp.replace.js";
import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { modules } from 'const';
import { loadExperiments, setActiveExperiment, switchExperiment } from 'redux/actions/experiments';
import DataProcessingIntercept from 'components/data-processing/DataProcessingIntercept';
import loadSecondaryAnalyses from 'redux/actions/secondaryAnalyses/loadSecondaryAnalyses';
import setActiveSecondaryAnalysis from 'redux/actions/secondaryAnalyses/setActiveSecondaryAnalysis';
import termsOfUseNotAccepted from 'utils/termsOfUseNotAccepted';

/**
 * AppRouteProvider provides a context which allows for checking and interception
 * of navigation between parts of the application. This allows implemenation of middlewares
 * when navigating between pages.
 *
 * AppRouteProvider wraps the application and exposes `useAppRouter`, which returns
 * an object containing the function `navigateTo`. The function takes in the path to be
 * go to and performs matching and determine actions which have to be carried out before
 * navigating to the route.
 *
 * Use `navigateTo` when implementing navigation between pages. Do not use `router.push` directly
 * as it will bypass the route checks and middlewares.
 */

var PATH_REGEX = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, modules.SECONDARY_ANALYSIS_OUTPUT, '/status'), modules.SECONDARY_ANALYSIS, '/pipeline'), modules.DATA_MANAGEMENT, '/data-management'), modules.REPOSITORY, '/repository'), modules.DATA_PROCESSING, '/data-processing'), modules.DATA_EXPLORATION, '/data-exploration'), modules.PLOTS_AND_TABLES, '/plots-and-tables'), modules.SETTINGS, '/settings'), modules.DEFAULT, '/');
var PATHS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, modules.SECONDARY_ANALYSIS, "".concat(PATH_REGEX[modules.SECONDARY_ANALYSIS])), modules.SECONDARY_ANALYSIS_OUTPUT, "/pipeline/[secondaryAnalysisId]".concat(PATH_REGEX[modules.SECONDARY_ANALYSIS_OUTPUT])), modules.DATA_MANAGEMENT, "".concat(PATH_REGEX[modules.DATA_MANAGEMENT])), modules.REPOSITORY, "".concat(PATH_REGEX[modules.REPOSITORY])), modules.DATA_PROCESSING, "/experiments/[experimentId]".concat(PATH_REGEX[modules.DATA_PROCESSING])), modules.DATA_EXPLORATION, "/experiments/[experimentId]".concat(PATH_REGEX[modules.DATA_EXPLORATION])), modules.PLOTS_AND_TABLES, "/experiments/[experimentId]".concat(PATH_REGEX[modules.PLOTS_AND_TABLES])), modules.SETTINGS, "".concat(PATH_REGEX[modules.DATA_MANAGEMENT], " /[settingsName]"));
var AppRouterContext = /*#__PURE__*/React.createContext(null);
var AppRouteProvider = function AppRouteProvider(props) {
  var children = props.children;
  var router = useRouter();
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user.current;
  }, _isEqual);
  var domainName = useSelector(function (state) {
    var _state$networkResourc;
    return (_state$networkResourc = state.networkResources) === null || _state$networkResourc === void 0 ? void 0 : _state$networkResourc.domainName;
  }, _isEqual);
  var _useState = useState(null),
    renderIntercept = _useState[0],
    setRenderIntercept = _useState[1];
  var _useState2 = useState(module.DATA_MANAGEMENT),
    currentModule = _useState2[0],
    setCurrentModule = _useState2[1];
  useEffect(function () {
    var _Object$entries$find = Object.entries(PATH_REGEX).find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          path = _ref2[1];
        return router.pathname.match(path);
      }),
      _Object$entries$find2 = _slicedToArray(_Object$entries$find, 1),
      moduleName = _Object$entries$find2[0];
    setCurrentModule(moduleName);
  }, [router.pathname]);
  useEffect(function () {
    if (router.pathname.startsWith('/experiments') || router.pathname === '/data-management') {
      localStorage.setItem('lastVisitedPage', modules.DATA_MANAGEMENT);
    } else if (router.pathname.startsWith('/pipeline')) {
      localStorage.setItem('lastVisitedPage', modules.SECONDARY_ANALYSIS);
    }
  }, [router.pathname]);
  var changedQCFilters = useSelector(function (state) {
    return state.experimentSettings.processing.meta.changedQCFilters;
  });
  var availableIntercepts = {
    DATA_PROCESSING: function DATA_PROCESSING(nextRoute) {
      return __jsx(DataProcessingIntercept, {
        onContinueNavigation: function onContinueNavigation() {
          return router.push(nextRoute);
        },
        onDismissIntercept: function onDismissIntercept() {
          return setRenderIntercept(null);
        }
      });
    }
  };
  var handleRouteChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(previousRoute, module, params, ignoreIntercepts, hardLoad) {
      var nextRoute, experimentId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nextRoute = PATHS[module].replace('[experimentId]', params.experimentId).replace('[secondaryAnalysisId]', params.secondaryAnalysisId);
              if (!nextRoute.match(PATH_REGEX.REPOSITORY)) {
                _context.next = 4;
                break;
              }
              router.push(nextRoute);
              return _context.abrupt("return");
            case 4:
              if (!(previousRoute.match(PATH_REGEX.DATA_PROCESSING) && changedQCFilters.size > 0 && !ignoreIntercepts)) {
                _context.next = 7;
                break;
              }
              setRenderIntercept(availableIntercepts.DATA_PROCESSING(nextRoute));
              return _context.abrupt("return");
            case 7:
              if ((previousRoute.match(PATH_REGEX.DATA_MANAGEMENT) || previousRoute.match(PATH_REGEX.REPOSITORY)) && nextRoute.match('experiments')) {
                experimentId = params.experimentId;
                dispatch(switchExperiment(experimentId));
              }
              if (!(nextRoute.match(PATH_REGEX.SECONDARY_ANALYSIS) && !nextRoute.match(PATH_REGEX.SECONDARY_ANALYSIS_OUTPUT))) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return dispatch(loadSecondaryAnalyses());
            case 11:
              // TODO check if this will be needed
              if (params.secondaryAnalysisId) {
                dispatch(setActiveSecondaryAnalysis(params.secondaryAnalysisId));
              }
            case 12:
              if (!(nextRoute.match(PATH_REGEX.DATA_MANAGEMENT) && !termsOfUseNotAccepted(user, domainName))) {
                _context.next = 16;
                break;
              }
              _context.next = 15;
              return dispatch(loadExperiments());
            case 15:
              if (params.experimentId) {
                dispatch(setActiveExperiment(params.experimentId));
              }
            case 16:
              // using hard load for the secondary analysi outputs
              // page because we need to load the analysis info
              // without hardLoad, the secondaryAnalysisId is
              // not present in the query (see _app.jsx file - loadAnalysisInfo)
              if (hardLoad || nextRoute.match(PATH_REGEX.SECONDARY_ANALYSIS_OUTPUT)) {
                window.location = nextRoute;
              } else {
                router.push(nextRoute);
              }
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleRouteChange(_x, _x2, _x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  var navigateTo = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(module) {
      var params,
        ignoreIntercepts,
        hardLoad,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              ignoreIntercepts = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              hardLoad = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
              return _context2.abrupt("return", handleRouteChange(router.pathname, module, params, ignoreIntercepts, hardLoad));
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function navigateTo(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  var forceNavigateToUrl = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              window.location = url;
            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function forceNavigateToUrl(_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  var value = useMemo(function () {
    return {
      navigateTo: navigateTo,
      currentModule: currentModule,
      forceNavigateToUrl: forceNavigateToUrl
    };
  }, [navigateTo, currentModule, forceNavigateToUrl]);
  return __jsx(AppRouterContext.Provider, {
    value: value
  }, renderIntercept !== null && renderIntercept !== void 0 ? renderIntercept : null, children);
};
var useAppRouter = function useAppRouter() {
  return useContext(AppRouterContext);
};
export { useAppRouter, PATHS };
export default AppRouteProvider;